(function () {
  'use strict';

  var revealSelector = '#MainContent .shopify-section:not(#shopify-section-banner)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    return;
  }

  document.body.classList.add('home-motion-ready');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  function registerSections(root) {
    var scope = root || document;
    var sections = scope.matches && scope.matches(revealSelector)
      ? [scope]
      : scope.querySelectorAll(revealSelector);

    Array.prototype.forEach.call(sections, function (section, index) {
      if (section.hasAttribute('data-home-reveal-ready')) return;

      section.setAttribute('data-home-reveal-ready', 'true');
      section.classList.add('slimeatory-home-reveal');
      section.style.setProperty('--home-reveal-delay', (index % 3) * 55 + 'ms');
      observer.observe(section);
    });
  }

  registerSections(document);

  document.addEventListener('shopify:section:load', function (event) {
    registerSections(event.target);
  });
}());